<script lang="ts">
export default {
  name: 'UILayer',
};
</script>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { TowerInfo } from './AccountTowerVisualizer';
import { TowerCardData, TowerType } from '@/views/tower_dashboard/types/tower-dashboard';
import ExportList from '@/views/tower_visualizer/ExportList.vue';
import ExportButton from '@/views/tower_visualizer/ExportButton.vue';
import { ChevronsLeft } from '@lucide/vue';
import Zoom from '@/views/tower/v2/Zoom.vue';

const towerInfo = inject<TowerInfo>('towerInfo');

const emit = defineEmits<{
  goBack: [];
}>();

const activeTower = computed(() => {
  return towerInfo?.selectedTower.value;
});

function getTowerName(towerCard: TowerCardData): string {
  if (towerCard.towerTypeId === TowerType.MultiTower) {
    return 'Multi-Tower';
  } else if (towerCard.program) {
    return towerCard.program.name;
  } else if (towerCard.towerName) {
    return towerCard.towerName;
  }

  return '';
}
</script>

<template>
  <div
    class="absolute grid justify-items-start w-full h-full pointer-events-none z-20 opacity-95"
  >
    <div class="pt-1 flex row-start-1 col-start-1">
      <div
        @click="emit('goBack')"
        class="h-fit bg-base-200 border border-solid border-gray-300 flex items-center justify-center cursor-pointer pointer-events-auto border-box rounded-md shadow-lg hover:bg-gray-300 transition-all px-1 py-1 m-2"
      >
        <ChevronsLeft class="scale-75" />
        <span class="mr-2">Back</span>
      </div>
      <div v-if="activeTower" class="flex flex-col pl-2 h-fit items-center">
        <span v-if="activeTower.versionLabel" class="font-bold">{{ activeTower.versionLabel }}</span>
        <span class="text-xs">{{ getTowerName(activeTower) }}</span>
      </div>
    </div>
    <Zoom 
      class="w-40 pr-2 col-start-1"
      bg-color="base-200"
      border-color="gray-300"
    />
    <div class="col-start-2 row-start-2 flex flex-col w-full h-full justify-end">
      <ExportList class="w-40 pr-2 self-end" />
      <ExportButton />
    </div>
  </div>
</template>
